import type { KeyboardEvent } from 'react';
import { Image } from '../design-system';
import { PotentialHitPricePill } from '../design-system/PotentialHitPricePill';
import type { IframePoolItem } from '../api';

export interface PotentialHitItemProps {
  item: IframePoolItem;
  onClick?: (item: IframePoolItem) => void;
}

const CARD_BG =
  'linear-gradient(180deg, #C2C3C5 -16.4%, #F7F8F8 121.88%), #FFF';

export function PotentialHitItem({ item, onClick }: PotentialHitItemProps) {
  const interactive = typeof onClick === 'function';
  return (
    <article
      className={
        'relative aspect-[195/287] overflow-hidden ' +
        'rounded-[20px] border border-[#EAEAEB] ' +
        (interactive
          ? 'cursor-pointer transition-transform duration-150 hover:scale-[1.02] active:scale-[0.98]'
          : '')
      }
      style={{ background: CARD_BG }}
      aria-label={item.title || 'Potential hit'}
      {...(interactive
        ? {
            role: 'button',
            tabIndex: 0,
            onClick: () => onClick!(item),
            onKeyDown: (e: KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick!(item);
              }
            },
          }
        : {})}
    >
      <Image
        src={item.imageUrl}
        alt={item.title || 'Potential hit'}
        className="absolute inset-0"
        imgClassName="absolute inset-0 h-full w-full object-cover"
        width={195}
        height={287}
        quality={95}
      />

      <PotentialHitPricePill price={formatPrice(item.itemPrice)} />
    </article>
  );
}

function formatPrice(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0.00';
  return value.toFixed(2);
}
